import aT from '../const/action-type'
import initial from '../store/initial'

export default (state = initial.tasks, action) => {
  switch (action.type) {
    case aT.SET_TASKS:
      return action.data
    case aT.RESET_STORE:
      return initial.tasks
    case aT.SWITCH_WORKSPACE:
      return initial.tasks
    default:
      return state
  }
}
